<div class="flex flex-wrap gap-2 pt-2 pb-4 justify-center lg:justify-center">
  <!-- WhatsApp -->
  <a *ngIf="social_networks.whatsapp" href="https://wa.me/{{ countryCode }}{{ social_networks.whatsapp }}"
    target="_blank"
    class="flex items-center py-1 px-1 text-base font-normal text_white rounded-lg button_color_customize group transition-all duration-200 hover:button_color_customize">
    <div class="text_color_customize w-8 h-8 p-1 rounded-lg text-center grid place-items-center group-hover:text_black">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
        <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
      </svg>
    </div>
  </a>

  <!-- Facebook -->
  <a *ngIf="social_networks.facebook" href="{{ facebookLink }}" target="_blank"
    class="flex items-center py-1 px-1 text-base font-normal text_white rounded-lg button_color_customize group transition-all duration-200 hover:button_color_customize">
    <div class="text_color_customize w-8 h-8 p-1 rounded-lg text-center grid place-items-center group-hover:text_black">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-brand-facebook">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
      </svg>
    </div>
  </a>

  <!-- Instagram -->
  <a target="_blank" *ngIf="social_networks.instagram" href="{{ instagramLink }}"
    class="flex items-center py-1 px-1 text-base font-normal text_white rounded-lg button_color_customize group transition-all duration-200 hover:button_color_customize">
    <div class="text_color_customize w-8 h-8 p-1 rounded-lg text-center grid place-items-center group-hover:text_black">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-brand-instagram">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        <path d="M16.5 7.5v.01" />
      </svg>
    </div>
  </a>

  <!-- TikTok -->
  <a target="_blank" *ngIf="social_networks.tiktok" href="{{ tikTokLink }}"
    class="flex items-center py-1 px-1 text-base font-normal text_white rounded-lg button_color_customize group transition-all duration-200 hover:button_color_customize">
    <div class="text_color_customize w-8 h-8 p-1 rounded-lg text-center grid place-items-center group-hover:text_black">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-brand-tiktok">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path
          d="M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z" />
      </svg>
    </div>
  </a>
</div>